import { FileTypeError, ParameterError } from '../utils/customErrors'
import { firestore, storage } from '../utils/firebase'

export default class Contest {

  static async create ({title, authorName, authorEmail, category, description, document}) {
    
    console.log(document.type)

    if(typeof(title) !== 'string' || typeof(authorName) !== 'string'
      || typeof(description) !== 'string' || typeof(category) !== 'string' || typeof(authorEmail) !== 'string'){

        throw new ParameterError('Incorrect parameter')

    }else if(document.type !== 'application/pdf' && !document.type.startsWith('image') 
      && document.type !== 'video/mp4'){

      throw new FileTypeError('Incorrect type of document')

    }

    document = await storage.ref(`contests/${title}-${authorName}`).put(document).then((snapshot) => {
      return snapshot.ref.getDownloadURL()
    })

    await firestore.collection('contests').add({
      title,
      authorName,
      authorEmail,
      category,
      description,
      document
    })

  }

  static async read (){

    return firestore.collection('contests').get().then(response => {
      return response.docs.map(doc => {
          return Object.assign({ id: doc.id }, doc.data())
      })
    })

  }

  static async search(id){

    if(typeof(id) !== 'string'){
      throw new ParameterError('Incorrect parameter')
    }

    return firestore.collection('contests').doc(id).get().then(response => {
      return Object.assign({id: response.id}, response.data())
    })

  }

  static async readByCategory(category){
    if(typeof(category) !== 'string'){
      throw new ParameterError('Incorrect parameter')
    }

    let contests = await this.readApproved()

    return contests.filter(contest => {
      return contest.category === category
    })

  }

  static async readApproved(){
    return firestore.collection('contests').where('approvedFile', '==', true).get().then(response => {
      return response.docs.map(doc => {
          return Object.assign({ id: doc.id }, doc.data())
      })
    })
  }

  static async readInAnalysis(){
    return await this.read().then(response => {
      return response.filter(contest => {
        if(contest.approvedFile === undefined){
          return true
        }
        return false

      })
    })
  }
  
  static async evaluate(id, result) {
    if (typeof id !== 'string') {
      throw new ParameterError('incorrect id')
    }

    if (typeof result !== 'boolean') {
      throw new ParameterError('incorrect result')
    }

    await firestore.collection('contests').doc(id).update({ approvedFile: result })
  }
  
}
